import { getInitialState } from './state';

const mutations = {
  SET_CLEAR_CURRENTADMISSION(state) {
    Object.assign(state, getInitialState());
  },

  SET_ADMISSION_QUESTIONS(state, questions) {
    state.data.questions = questions;
  },

  SET_ADMISSION_ID(state, admissionId) {
    state.data.id = admissionId;
  },

  SET_ADMISSION_DATA(state, admission) {
    Object.assign(state.data, admission);
  },

  SET_ADMISSION_MEDICAL_ORDERS(state, medicalOrders) {
    if (medicalOrders) {
      state.data.medicalOrders = medicalOrders;
    }
  },

  SET_ADMISSION_PAYMENT(state, payment) {
    if (payment) {
      state.data.payments = [payment];
    }
  },

  SET_ADMISSION_PATIENT_CIP(state, cip) {
    state.data.patient.cip = cip;
  },

  SET_ADMISSION_STATUS(state, status) {
    state.data.status = status;
  },

  SET_ADMISSION_PAYMENT_METHOD(state, paymentMethod) {
    state.data.paymentMethod = paymentMethod;
  },
};

export default mutations;
